module.exports = __webpack_public_path__ + "static/images/moca.2HRJdFj.svg";